import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {AppStateService} from '../../services/appstate/app.state.service';
import {CustomRouterService} from '../../services/custom-router.service';
import {environment} from '../../../environments/environment';
import {hasAdminMfaConfigured} from '../../util/admin-mfa.util';
import {isAdminPortalUserType} from '../../services/admin-portal-user.util';

/**
 * When `requireMfaForAdminLogin` is true, authenticated admins without MFA configured
 * are redirected to the MFA setup route instead of the dashboard.
 */
@Injectable({providedIn: 'root'})
export class MfaEnforcementGuard implements CanActivate {
  constructor(
    private readonly appState: AppStateService,
    private readonly router: Router,
    private readonly customRouter: CustomRouterService,
  ) {}

  canActivate(): boolean | UrlTree {
    if (!environment.requireMfaForAdminLogin || !this.appState.isBrowser) {
      return true;
    }
    const user = this.appState.user.userDetails;
    if (!user || !isAdminPortalUserType(user.userType)) {
      return true;
    }
    if (hasAdminMfaConfigured(user)) {
      return true;
    }
    const path = '/' + this.customRouter.getRoutePathTranslated('auth/setup-mfa');
    return this.router.parseUrl(path);
  }
}
